var _path, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKakao(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 19C38.5 29.4934 29.9934 38 19.5 38C9.00659 38 0.5 29.4934 0.5 19C0.5 8.50659 9.00659 0 19.5 0C29.9934 0 38.5 8.50659 38.5 19Z",
    fill: "#FAE100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1363_14306)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5532 10.7656C14.6257 10.7656 10.6328 13.9366 10.6328 17.8503C10.6328 20.3965 12.3247 22.6303 14.8643 23.8779C14.6781 24.5771 14.1883 26.4132 14.0907 26.8055C13.9696 27.2922 14.2678 27.2868 14.463 27.156C14.6167 27.0525 16.9069 25.487 17.8956 24.8132C18.4325 24.8931 18.9856 24.9349 19.5514 24.9349C24.477 24.9349 28.4717 21.764 28.4717 17.8503C28.4717 13.9366 24.4788 10.7656 19.5532 10.7656Z",
    fill: "#371D1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1363_14306"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.8389,
    height: 16.4667,
    fill: "white",
    transform: "translate(10.6328 10.7656)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKakao);
export default __webpack_public_path__ + "static/media/kakao.a87022eedab788f684435ab01231fb38.svg";
export { ForwardRef as ReactComponent };